import { render, staticRenderFns } from "./ActivitiesListingSettingsHeader.vue?vue&type=template&id=27f2b75b&"
import script from "./ActivitiesListingSettingsHeader.vue?vue&type=script&lang=js&"
export * from "./ActivitiesListingSettingsHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports